import React, { forwardRef } from 'react';

import './MentionDropdown.scss';

type Props = {
  children?: Array<{
    props: {
      mention: {
        in_same_org: boolean;
        collaborator: boolean;
        isWorkspaceMember: boolean;
      };
    };
  }>;
  className?: string;
  id?: string;
  role?: string;
};

type ForwardedRef = {
  current: HTMLDivElement;
};

const MentionDropdown = forwardRef(({ children, className, id, role }: Props, ref: ForwardedRef) => (
  <div ref={ref} id={id} role={role} className={`${className} mention-dropdown`}>
    {children}
  </div>
));

export default MentionDropdown;
